/* eslint-disable no-use-before-define */
/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
/* eslint-disable camelcase */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-cycle */

import axios from 'axios';
import jwt_decode from 'jwt-decode';
import config from '../../config';
import { userServices } from './userServices';
import { userConstants } from '../constants/userConstants';
import store from '../../containers/App/store';
import { authHeader } from '../../helpers/authHeader';

const main = axios.create();

axios.defaults.baseURL = config.API_URL;
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.put['Content-Type'] = 'application/json';

main.defaults.baseURL = config.API_URL;
main.defaults.headers.post['Content-Type'] = 'application/json';
main.defaults.headers.put['Content-Type'] = 'application/json';

main.interceptors.request.use(
  (config) => {
    const token = authHeader();
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

let isRefreshing = false;

let subscribers = [];

main.interceptors.response.use(undefined, (err) => {
  const { config, response: { status } } = err;
  const originalRequest = config;
  const state = store.getState();
  const decodedToken = jwt_decode(state.authentication.auth.token);
  const userEmail = decodedToken.email;

  if (status === 401) {
    if (!isRefreshing) {
      isRefreshing = true;
      userServices.refreshAuth(userEmail, state.authentication.auth.refreshToken)
        .then((response) => {
          const auth = response;
          isRefreshing = false;
          onRrefreshed(auth.token);
          store.dispatch({ type: userConstants.LOGIN_REFRESH_SUCCESS, auth });
          subscribers = [];
        });
    }
    const requestSubscribers = new Promise((resolve) => {
      subscribeTokenRefresh((token) => {
        originalRequest.headers.Authorization = `Token ${token}`;
        resolve(axios(originalRequest));
      });
    });
    return requestSubscribers;
  }
  return Promise.reject(err);
});

function subscribeTokenRefresh(cb) {
  subscribers.push(cb);
}

function onRrefreshed(token) {
  subscribers.map((cb) => cb(token));
}

export const apiClient = main;

export function handleResponse(response) {
  const { data } = response;

  if (!response.statusText === 'OK') {
    if (response.status === 401) {
      // auto logout if 401 response returned from api
      userServices.logout();
    }
    const error = (data && data.message) || response.statusText;
    return Promise.reject(error);
  }
  return data;
}
